export default __webpack_public_path__ + "static/datastax-37e429b9b24419f3c066bb69810b15c1.svg";